import { Injectable } from "@angular/core";
import { StatoApplicazioneDTO } from "../dto/stato-applicazioneDTO";
import { StatoApplicazioneVO } from "../vo/stato-applicazioneVO";
import { MapperInterface } from "./mapper-inteface";

@Injectable({
  providedIn: "root"
})
export class MapperStatoApplicazione implements MapperInterface<StatoApplicazioneDTO, StatoApplicazioneVO> {
  constructor() { }

  convertVoToDto(vo: StatoApplicazioneVO): StatoApplicazioneDTO {
    // console.log("[MapperSettore] SettoreVO => SettoreDTO", settoreVO);
    return new StatoApplicazioneDTO();
  }

  convertDtoToVo(dto: StatoApplicazioneDTO): StatoApplicazioneVO {
    // console.log("[MapperSettore] SettoreDTO => SettoreVO", settoreDTO);
    const vo = new StatoApplicazioneVO();

    vo.manutenzione = dto.manutenzione;
    vo.messaggio = dto.messaggio;
    vo.dataInizioManutenzione = new Date(dto.dataInizioManutenzione);
    const statoElementi = dto.statoElementi;
    dto.statoElementi = new Map();
    if (statoElementi) {
      for (const key in Object.entries(statoElementi)) {
        console.log("menu ", key);
        dto.statoElementi.set(
          Object.entries(statoElementi)[key][0],
          Object.entries(statoElementi)[key][1]
        );
      }
    }
    if (dto.statoElementi.get("nascondiFascicolazione") === "true") {
      vo.nascondiFascicolazione = true;
    } else {
      vo.nascondiFascicolazione = false;
    }

    if (dto.statoElementi.get("nascondiVociPhylum") === "true") {
      vo.nascondiVociPhylum = true;
    } else {
      vo.nascondiVociPhylum = false;
    }

    console.log("[MapperStatoApplicazione] fine StatoApplicazioneDTO => StatoApplicazioneVO", vo);
    return vo;
  }

  convertListVoToDto(voList: StatoApplicazioneVO[]): StatoApplicazioneDTO[] {
    return [];
  }

  convertListDtoToVo(dtoList: StatoApplicazioneDTO[]): StatoApplicazioneVO[] {
    return [];
  }
}
